export const en = {
  msg: {
    // login
    'login': 'Login',
    'username_error_required': 'Please enter your username.',
    'username_error_max': 'Please enter your username.',
    'username_error_regex': 'Please enter your username.',
    'password_error_required': 'Please enter your password.',
    'password_error_max': 'Please enter your password.',
    'password_error_regex': 'Please enter your password.',
    'error': 'Invalid username or password',
    'blank_username_field': 'Please enter your username.',
    'blank_password_field': 'Please enter your password.',
    'password_error_confirmed': 'Password does not match with new Password.',
    'invalid_credentials': 'Please enter a valid username or password.',
    'copyright': 'Powered by Global Psytech',
    'username_label': 'Username',
    'password_label': 'Password',
    'new_password_label': 'New Password',
    'new_confirm_password_label': 'New Confirm Password',
    'id_number_label': 'ID Number',
    'serverError': 'Sorry, something went wrong. Please try again.',
    'footer_text': 'Global Psytech Sdn. Bhd.',
    'login_button': 'Login',

    // Results Page
    'assessmentDropdownLabel': 'Assessment',
    'sessionDropdownLabel': 'Session',
    'divisionDropdownLabel': 'Division',
    'departmentDropdown': 'Department',
    'registered_employees_text': 'Registered Employees',
    'finished_employees_text': 'Finished',
    'results_page_heading_name': 'Results',
    'filters': 'Filters',
    'table_heading': 'List of Individual Test Report',
    'search': 'Search',
    'close_label': 'Close',
    // Table Headers (Results Page)
    'table_header_no': 'No',
    'table_header_name': 'Name',
    'table_header_employeeId': 'Employee Id',
    'table_header_assessment_name': 'Assessment Name',
    'table_header_assessment_session': 'Session',
    'table_header_report': 'Report',
    'table_header_division': 'Division',
    'table_header_department': 'Department',
    'table_header_unit': 'Unit',
    'table_header_option': 'Options',
    'search_placeholder': 'Search',
    // Header
    'logout': 'Logout',
    // SideBar
    'sidebar_text_dashboard': 'Dashboard',
    'sidebar_text_results': 'Results',
    // TimeOut Dialog
    'session_expire_heading': 'Session Expiring Warning',
    'session_expire_message_1': 'Your session will expire in',
    'session_expire_message_2': 'seconds',
    // Report Unavailable
    'report_unavailable': 'Please wait while the report is being generated.<br>If the problem persists please contact support',
    // Loader
    'loading': 'Loading',
    // Table Headers (Growth Profile Page)
    'table_header_gp_date': 'Date',
    'table_header_gp_assessment_name': 'Assessment Name',
    'table_header_gp_programme_name': 'Programme Name',
    'table_header_gp_assessment_session': 'Session',
    'table_header_gp_status': 'Status',
    'table_header_gp_report': 'Reports',
    // Registration error
    'full name (as per nric)_error_required': 'Please enter customers full name as indicated on NRIC.',
    'full name (as per nric)_error_regex': 'Only acceptable characters include letters of the alphabet and special characters such as @ ‘ / - .',
    'full name (as per nric)_error_max': 'The name cannot be longer than 80 characters.',
    'identification number (id)_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
    'identification number (id)_error_required': 'Please enter NRIC/ passport number.',
    'gender_error_required': 'Please select gender.',
    'ethnicity_error_required': 'Please select ethnicity.',
    'application id_error_required': 'Please enter customers application ID.',
    'application id_error_max': 'The application ID must not be longer than 15 characters.',
    'application id_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
    'business registration (br) no_error_required': 'Please enter company’s BR number.',
    'business registration (br) no_error_max': 'The BR number must not be longer than 15 characters.',
    'business registration (br) no_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
    'company name_error_required': 'Please enter company’s name.',
    'company name_error_max': 'The company name must not be longer than 80 characters.',
    'company name_error_regex': 'The only acceptable characters are letters of the alphabet, spaces, numerals, and the following special characters: . - & () and ’',
    'business category_error_required': 'Please select company’s business categories.',
    'financing amount requested (rm)_error_required': 'Please enter financing amount.',
    'financing amount requested (rm)_error_numeric': 'This entry can only contain numbers.',
    'financing amount requested (rm)_error_min_value': 'The financing amount requested must be at least RM 10,000.',
    'financing amount requested (rm)_error_max_value': 'The financing amount must not exceed RM 2,500,000.',
    'financing tenure_error_required': 'Please enter financing tenure.',
    'financing tenure_error_min_value': 'The tenure amount requested must be at least 1.',
    'financing tenure_error_max_value': 'The tenure amount must not exceed 84.',
    'programme applied_error_required': 'Please select programme applied.',
    'facility applied_error_required': 'Please select facility applied.',
    'region_error_required': 'Please select region.',
    'orr_error_required': 'Please enter ORR.',
    'orr_error_numeric': 'The only acceptable characters are letters of the alphabet and numerals.',
      'financing amount_error_required':'Please enter financing amount.',
      'financing amount_error_numeric':'This entry can only contain numbers.',
      'financing amount_error_min_value':'The financing amount requested must be at least RM 10,000.',
      'financing amount_error_max_value':'The financing amount must not exceed RM 2,500,000.',
      'email_error_required': 'Please enter email address.',
      'email_error_email': 'Please enter a valid email address.'
  }
}
